__turbopack_context__.v({
  "backBtn": "pos-module__yqSpaa__backBtn",
  "cartBody": "pos-module__yqSpaa__cartBody",
  "cartClearBtn": "pos-module__yqSpaa__cartClearBtn",
  "cartCountTag": "pos-module__yqSpaa__cartCountTag",
  "cartHeader": "pos-module__yqSpaa__cartHeader",
  "cartHeaderLeft": "pos-module__yqSpaa__cartHeaderLeft",
  "cartIconWrapper": "pos-module__yqSpaa__cartIconWrapper",
  "cartItem": "pos-module__yqSpaa__cartItem",
  "cartItemControls": "pos-module__yqSpaa__cartItemControls",
  "cartItemInfo": "pos-module__yqSpaa__cartItemInfo",
  "cartList": "pos-module__yqSpaa__cartList",
  "cartModal": "pos-module__yqSpaa__cartModal",
  "cartOverlay": "pos-module__yqSpaa__cartOverlay",
  "cartSummary": "pos-module__yqSpaa__cartSummary",
  "cartTitleText": "pos-module__yqSpaa__cartTitleText",
  "cartTotalLabel": "pos-module__yqSpaa__cartTotalLabel",
  "cashForm": "pos-module__yqSpaa__cashForm",
  "checkoutBtn": "pos-module__yqSpaa__checkoutBtn",
  "closeCartBtn": "pos-module__yqSpaa__closeCartBtn",
  "emptyBagIcon": "pos-module__yqSpaa__emptyBagIcon",
  "emptyCartBox": "pos-module__yqSpaa__emptyCartBox",
  "emptyCartText": "pos-module__yqSpaa__emptyCartText",
  "fadeIn": "pos-module__yqSpaa__fadeIn",
  "methodBtn": "pos-module__yqSpaa__methodBtn",
  "methodBtnActive": "pos-module__yqSpaa__methodBtnActive",
  "onlineBox": "pos-module__yqSpaa__onlineBox",
  "payBtn": "pos-module__yqSpaa__payBtn",
  "paymentActions": "pos-module__yqSpaa__paymentActions",
  "paymentInfoRow": "pos-module__yqSpaa__paymentInfoRow",
  "paymentLabel": "pos-module__yqSpaa__paymentLabel",
  "paymentMethodRow": "pos-module__yqSpaa__paymentMethodRow",
  "paymentPanel": "pos-module__yqSpaa__paymentPanel",
  "qtyBtn": "pos-module__yqSpaa__qtyBtn",
  "qtyText": "pos-module__yqSpaa__qtyText",
  "quickCashBtn": "pos-module__yqSpaa__quickCashBtn",
  "quickCashBtnPrimary": "pos-module__yqSpaa__quickCashBtnPrimary",
  "quickCashRow": "pos-module__yqSpaa__quickCashRow",
  "slideUp": "pos-module__yqSpaa__slideUp",
  "startShoppingBtn": "pos-module__yqSpaa__startShoppingBtn",
});
